var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-password_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-password_svg__st0{fill:#050505}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-password_svg__st0",
    d: "M2.9 12.4l-2.4-.7.4-1.2 2.4.9-.1-2.7h1.2l-.1 2.7 2.3-.9.4 1.2-2.4.7 1.5 2.1-1 .7L3.6 13l-1.4 2.2-1-.7 1.7-2.1zM11.3 12.4l-2.4-.7.4-1.2 2.4.9-.1-2.7h1.2l-.1 2.7 2.3-.9.4 1.2-2.4.8 1.5 2.1-1 .7-1.5-2.2-1.4 2.2-1-.7 1.7-2.2zM19.4 12.4l-2.4-.7.4-1.2 2.4.9-.1-2.7h1.2l-.1 2.7 2.3-.9.4 1.2-2.4.7 1.5 2.1-1 .7-1.5-2.2-1.4 2.2-1-.7 1.7-2.1z"
  })));
}

export default SvgIconPassword;